/* src/app/warehousing/pages/dashboard/dashboard.component.scss */
/*# sourceMappingURL=dashboard.component.css.map */
